import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import Vue from 'vue'
import VueTippy, { TippyComponent } from 'vue-tippy'
import VueMeta from 'vue-meta'
import { ValidationProvider, extend } from 'vee-validate'
import Noty from 'noty'
import numeral from 'numeral'
import * as rules from 'vee-validate/dist/rules'
import moment from 'moment'
import HandleDrawerActions from './mixins/HandleDrawerActions'
import Mousetrap from 'mousetrap'
import axios from 'axios'
import Echo from 'laravel-echo'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Vue.use(plugin)
Vue.mixin({
  computed: {
    url () {
      return location.pathname.substr(1) + location.search
    },
  },
  mounted () {
    Mousetrap.bind('/', (e) => {
      document.getElementById('topbar-search').focus()

      e.preventDefault()
    })
  },
  methods: {
    route: window.route,
    isUrl(...urls) {
      if (urls[0] === '') {
        return this.url === ''
      }

      return urls.filter(url => this.url.startsWith(url)).length
    },
    isUrlExact (url) {
      return this.url === url
    },
  },
})

Vue.filter('numeral', function(value, format = '0,0.00') {
  return numeral(value).format(format)
})
Vue.filter('uppercase', function(value) {
  return value.toUpperCase()
})
Vue.filter('titlecase', function(value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('moment', function(value, format = 'LL') {
  if (format === 'from') {
    return moment(value).fromNow()
  }

  return value ? moment(value).format(format) : '—'
})

Vue.mixin(HandleDrawerActions)

Vue.use(VueTippy)
Vue.component('Tippy', TippyComponent)
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueMeta)

/* Mount the EventBus */
Vue.prototype.$eventHub = new Vue()

Vue.prototype.$noty = {
  success (text) {
    new Noty({
      type: 'success',
      text,
      timeout: 3000,
      animation: {
        open: 'animate__animated animate__fadeInUp',
        close: 'animate__animated animate__fadeOutDown',
      },
      theme: 'mint',
      layout: 'bottomCenter',
    }).show()
  },
  error (text) {
    new Noty({
      type: 'error',
      text,
      timeout: 3000,
      animation: {
        open: 'animate__animated animate__fadeInUp',
        close: 'animate__animated animate__fadeOutDown',
      },
      theme: 'mint',
      layout: 'bottomCenter',
    }).show()
  },
}

window.io = require('socket.io-client')

Vue.prototype.$echo = new Echo({
  broadcaster: 'socket.io',
  namespace: 'Stacks.Events',
  host: window.location.hostname,
})
Vue.prototype.$echo.connector.socket.on('connect', () => {
  axios.defaults.headers.common['X-Socket-ID'] = Vue.prototype.$echo.socketId()
})

InertiaProgress.init()

const el = document.getElementById('app')
const store = require('./store').default

new Vue({
  store,
  metaInfo: {
    titleTemplate: (title) => title ? `${title} — Stacks` : 'Stacks',
  },
  render: h => h(App, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: name => require(`./pages/${name}`).default,
    },
  }),
}).$mount(el)
